export default __webpack_public_path__ + "static/media/investigativeIcon.3c4dfcc3.png";